import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { Button } from '../../ui/button';
import { Checkbox } from '../../ui/checkbox';

export const TestControls = ({ d, call }) => {
  const [to, setTo] = useState('me');
  const t = d.last_test || {};
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <select value={to} onChange={(e) => setTo(e.target.value)} className="px-2 py-1.5 border rounded-md text-sm" data-testid="email-test-to">
        <option value="me">Send to my login email</option>
        {d.draft.reply_to && <option value="reply_to">Send to Reply-To ({d.draft.reply_to})</option>}
      </select>
      <Button size="sm" variant="outline" disabled={!d.checks.connection || !d.draft.sender_email} onClick={() => call('post', '/test', { to }, 'Test email sent')} data-testid="email-send-test"><Send className="w-4 h-4 mr-1" />Send Test Email</Button>
      {d.test_matches_draft && ['sent', 'delivered'].includes(t.last_event) && !t.reply_confirmed && (
        <Button size="sm" variant="outline" onClick={() => call('post', '/test/confirm-reply', {}, 'Receipt and reply confirmed')} data-testid="email-confirm-reply">I received it and my reply arrived</Button>
      )}
    </div>
  );
};

export const ActivatePanel = ({ d, call }) => {
  const [ok, setOk] = useState(false);
  const s = d.draft;
  if (d.draft_is_active) return <p className="text-sm text-emerald-700" data-testid="email-draft-is-active">These settings are the active sender.</p>;
  return (
    <div className="space-y-3" data-testid="email-activate-panel">
      <label className="flex items-start gap-2 text-sm"><Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} disabled={!d.ready_to_activate} data-testid="email-activate-confirm" />
        Send all customer emails from {s.from_name} &lt;{s.sender_email}&gt; via Resend. If Resend fails, the email is logged as failed and not sent another way.</label>
      <Button disabled={!d.ready_to_activate || !ok} onClick={() => call('post', '/activate', { confirm: true }, 'New sender is now active').then(() => setOk(false))} data-testid="email-activate">Activate New Sender</Button>
      {!d.ready_to_activate && <p className="text-xs text-neutral-500">Available once the API key is saved and all four checks are green. The current sender stays live until then.</p>}
    </div>
  );
};
